export default "__VITE_ASSET__9bt7$TnV__"